import { render } from 'preact'
import 'preact/debug'
import { useEffect } from 'preact/hooks'

import { LoadingIcon } from 'components/UI'
import { AuthenticatedRoutes, UnAuthenticatedRoutes } from 'routes'
import { AuthState, authState, initializeAuth } from 'state'
import { defaultTenantId, firebaseConfig } from 'config'
import { listenForAuthBroadcastChannelMessage } from 'utils'

import { MessageDialog } from './components/UI/organisms/modals/MessageDialog'

export const App = () => {
	useEffect(() => {
		initializeAuth(defaultTenantId, firebaseConfig)
		listenForAuthBroadcastChannelMessage()
	}, [])

	if (authState.value === AuthState.loading) {
		return (
			<div class='grid h-screen w-screen place-content-center'>
				<LoadingIcon class='h-10 w-10 text-product' />
			</div>
		)
	}

	return (
		<>
			<MessageDialog />
			{authState.value === AuthState.authenticated ? (
				<AuthenticatedRoutes />
			) : (
				<UnAuthenticatedRoutes />
			)}
		</>
	)
}

render(<App />, document.querySelector('#app')!)
